import { Button, Text } from '@components/ui';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

import { CardFields } from './card-fields';

interface AddCardDialogProps {
  open: boolean;
  clientToken: string | null;
  ready: boolean;
  saving: boolean;
  onClose: () => void;
  onSave: () => void;
}

export const AddCardDialog = ({
  open,
  clientToken,
  ready,
  saving,
  onClose,
  onSave,
}: AddCardDialogProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          m: 2,
        },
      }}
    >
      <DialogTitle sx={{ px: 3, pt: 2.5, pb: 1.5 }}>
        <Text as="span" variant="subtitle">
          {t('payments.addCard')}
        </Text>
      </DialogTitle>
      <DialogContent sx={{ px: 3, pt: 1, pb: 1 }}>
        {!clientToken ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress size={28} color="primary" />
          </Box>
        ) : (
          <CardFields />
        )}
      </DialogContent>
      {clientToken ? (
        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={saving}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="button"
            variant="primary"
            disabled={!ready}
            loading={saving}
            onClick={onSave}
          >
            {t('payments.saveCard')}
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
